import { render, staticRenderFns } from "./KpiEditor.vue?vue&type=template&id=389dcfec&scoped=true"
import script from "./KpiEditor.vue?vue&type=script&lang=js"
export * from "./KpiEditor.vue?vue&type=script&lang=js"
import style0 from "./KpiEditor.vue?vue&type=style&index=0&id=389dcfec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389dcfec",
  null
  
)

export default component.exports